import { FC, useState } from "react";
import countries from "world-countries";
import { Button, Modal } from "../../../components";
import { LoanProductType, Vendor } from "../../../hooks/api/types";
import TradeLicenseModal from "./TradeLicenseModal";
import { getVendorTitle } from "./utils";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  vendor: Vendor;
  loanApplicationId?: string;
  onVendorUpdate?: () => void;
  loanType?: LoanProductType;
};

const DeleteVendorModal: FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
  vendor,
  loanApplicationId,
  onVendorUpdate,
  loanType,
}) => {
  const [showTradeLicenseModal, setShowTradeLicenseModal] = useState(false);
  const country = countries.find((country) => country.cca3 === vendor.country);
  const vendorTitle = getVendorTitle(loanType as LoanProductType);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Delete ${vendorTitle}?`}
      subtitle={`Are you sure you want to delete ${vendorTitle}?`}
      variant="expanded"
      subtitleVariant="expanded"
    >
      <div className="cx-flex cx-flex-col cx-gap-4 ">
        <div className="cx-flex cx-flex-col cx-rounded-lg cx-p-4 cx-border cx-border-stroke-primary cx-min-w-[400px]">
          <div className="cx-flex cx-items-center cx-gap-3">
            <div className="cx-text-3xl">{country?.flag}</div>
            <div className="cx-flex cx-flex-col">
              <div className="cx-font-medium cx-text-base cx-text-text-primary">
                {vendor.name}
              </div>
              {vendor.licenseNumber && (
                <div className="cx-text-sm cx-text-text-secondary">
                  {vendor.licenseNumber}
                </div>
              )}
              {vendor?.documents?.length !== undefined &&
                vendor?.documents?.length > 0 && (
                  <div
                    className={
                      "cx-text-xs cx-font-medium cx-text-text-brand cx-cursor-pointer hover:cx-underline"
                    }
                    onClick={() => setShowTradeLicenseModal(true)}
                  >
                    View trade license
                  </div>
                )}
            </div>
          </div>
        </div>

        <div className="cx-flex cx-gap-3 cx-mt-4">
          <Button label="Cancel" onClick={onClose} outlined fullWidth />
          <Button
            label={`Delete ${vendorTitle}`}
            onClick={onConfirm}
            danger
            fullWidth
          />
        </div>
      </div>

      <TradeLicenseModal
        isOpen={showTradeLicenseModal}
        onClose={() => setShowTradeLicenseModal(false)}
        documentIds={vendor.documents?.map((doc) => doc.documentId) || []}
        vendor={vendor}
        loanApplicationId={loanApplicationId}
        onDocumentDelete={onVendorUpdate}
      />
    </Modal>
  );
};

export default DeleteVendorModal;
